import React,{useState, useEffect, useContext} from 'react'
import { useSelector } from 'react-redux';
import axios from 'axios';
import { jsonToURL } from '../../../../../utils';
import { ConfigContext } from '../../../../../App';
import './AddPlanModal.css'
import InputBar from '../../minda/InputBar/InputBar';
import AddPlanForm from './AddPlanForm';


export default function AddPlanModal({CloseAddPlanModel}) {

  const {mmHost} = useContext(ConfigContext);
  const [loading, setloading] = useState(false);
  const [fetchStatus, setFetchStatus] = useState(true); 
  const [addData, setaddData] = useState([]);

  let plantId = useSelector((state) => state.saveSelectedPlant);
  if(plantId.addPlanModal){
      plantId = plantId.addPlanModal.selectedOption.value;
  }else {
      plantId = "";
  }
  
  let lineId = useSelector((state) => state.saveSelectedLine);
if (lineId.addPlanModal) {
  lineId = lineId.addPlanModal.selectedOption.value;
} else {
  lineId = "";
}

let timings = useSelector((state) => state.timings);
timings = timings.plan;
let startDate = 1;
let endDate = 1;
if (timings) {
  const sDateAndTime = timings.startTime.toLocaleString("sv-SE")
  const correctedStartDate = sDateAndTime.slice(0,10);
  const correctedStartTime = sDateAndTime.slice(11,19)
  startDate = `${correctedStartDate}T${correctedStartTime}.000Z`
  const eDateAndTime = timings.endTime.toLocaleString("sv-SE")
  const correctedEndDate = eDateAndTime.slice(0,10);
  const correctedEndTime = eDateAndTime.slice(11,19)
  endDate = `${correctedEndDate}T${correctedEndTime}.000Z`
}
  
let queryParams = {
  startDate,
  endDate,
  plantId,
  lineId,
}; 

const updateData = async () => {

  let planURL = `${mmHost}/pplan?${jsonToURL(
    queryParams
  )}`;

  setloading(true);
  axios
    .get(planURL)
    .then(function (data) {
     setaddData(data.data);
      setloading(false);
      return;
    })
    .catch((e) => {
      setloading(false);
      console.log("you are just stuck in axios request", e);
      return;
    });
};

useEffect(() => {
  updateData();
}, [fetchStatus]);

useEffect(() => {
  setTimeout(() => {
    setFetchStatus(!fetchStatus);
  }, 500);
}, []);


  return (
    <>
    <div className="ModelBoxStyle" >
       <div className="modal-dialog modal-lg"> 
          <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Productoion Plan</h4>
                <button onClick={()=> CloseAddPlanModel(false)} type="button" className="close" >&times;</button>
              </div>
            <div className="modal-body" >
                                 <InputBar
                                    setData={setaddData}
                                    loading={loading}
                                    fetchStatus={fetchStatus}
                                    setFetchStatus={setFetchStatus}
                                    InsIden={"addPlanModal"}
                                    line={true}
                                    machine={true}
                                    shift={false}
                                    shiftDate={false}
                                    goback={false}
                                    defaultOptions={{
                                    line: [{ value: "", label: "All" }],
                                    plant: [{ value: "", label: "All" }],
                                    machine: [{ value: "", label: "All" }],
                                    }}
                                ></InputBar>
                   <AddPlanForm CloseAddPlanModel={CloseAddPlanModel} filteredData={addData}/>
                </div>
        </div>
    </div>
</div>
    
   
    </>
  )
}


